import React from 'react';
import { UploaderConsumer } from '../UploaderContext';






function AssetSelector({ assetId, children }) {
  return (
    <UploaderConsumer>
      {({ assetsMap }) => children(assetId ? assetsMap.get(assetId) : void 0)}
    </UploaderConsumer>);

}

export default AssetSelector;